import { useQuery } from '@tanstack/react-query';
import { Alert, App, Button, Space, Tree } from 'antd';
import { useState } from 'react';
import { api, errorText } from '../../api/client';
import type { Location, ProductDetail } from '../../api/types';
import { locationTree } from '../catalog/categoryTree';

/** Khu vực phục vụ (D-10): chọn cấp tỉnh là đủ – vùng tỉnh cũ bên trong tự được tính. */
export function ServiceAreasTab({
  product,
  canEdit,
  onSaved,
}: {
  product: ProductDetail;
  canEdit: boolean;
  onSaved: (p: ProductDetail) => void;
}) {
  const { message } = App.useApp();
  const locs = useQuery({
    queryKey: ['locations'],
    queryFn: () => api.get<Location[]>('/admin/locations'),
  });
  const [checked, setChecked] = useState<string[]>(product.service_areas.map((s) => s.location_id));
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      onSaved(
        await api.put<ProductDetail>(`/admin/products/${product.id}/service-areas`, {
          location_ids: checked,
        }),
      );
      message.success('Đã lưu khu vực phục vụ');
    } catch (e) {
      message.error(errorText(e));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      <Alert
        type="info"
        showIcon
        message="Chọn tỉnh là đủ: sản phẩm phục vụ TP. Hồ Chí Minh sẽ hiện khi khách chọn Bình Dương (cũ) hoặc Bà Rịa – Vũng Tàu (cũ)."
      />
      <Tree
        checkable
        checkStrictly
        defaultExpandAll
        disabled={!canEdit}
        treeData={locationTree(locs.data ?? [])}
        checkedKeys={checked}
        onCheck={(k) => setChecked((Array.isArray(k) ? k : k.checked).map(String))}
      />
      {canEdit && (
        <Button type="primary" onClick={() => void save()} loading={saving}>
          Lưu khu vực
        </Button>
      )}
    </Space>
  );
}
